import React from 'react';

export const SCHEDULE_TYPES = [
  { id: 'every_n_days', label: 'Каждые N дней' },
  { id: 'daily_from_monthly', label: 'Ежедневно из месячной суммы' },
  { id: 'monthly_day', label: 'День месяца' },
  { id: 'monthly_weekday', label: 'День недели в месяце' },
  { id: 'weekly', label: 'Еженедельно' },
  { id: 'yearly_date', label: 'Ежегодно' },
];

const WEEKDAYS = [
  { v: 0, label: 'Понедельник' },
  { v: 1, label: 'Вторник' },
  { v: 2, label: 'Среда' },
  { v: 3, label: 'Четверг' },
  { v: 4, label: 'Пятница' },
  { v: 5, label: 'Суббота' },
  { v: 6, label: 'Воскресенье' },
];

export function todayYmd() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function defaultScheduleState(anchor = todayYmd()) {
  return {
    type: 'monthly_day',
    interval_days: 30,
    anchor_date: anchor,
    day: 1,
    month: 1,
    short_month_policy: 'clamp_last',
    weekday: 0,
    ordinal: 1,
    interval_weeks: 1,
  };
}

export function scheduleFromApi(schedule) {
  const base = defaultScheduleState(schedule?.anchor_date || todayYmd());
  if (!schedule || !schedule.type) return base;
  return { ...base, ...schedule };
}

export function buildSchedulePayload(state) {
  const t = state.type;
  if (t === 'yearly_date') {
    return { type: t, month: Number(state.month), day: Number(state.day) };
  }
  if (t === 'daily_from_monthly') {
    return { type: t, anchor_date: state.anchor_date };
  }
  if (t === 'every_n_days') {
    return {
      type: t,
      interval_days: Number(state.interval_days) || 1,
      anchor_date: state.anchor_date,
    };
  }
  if (t === 'monthly_day') {
    return {
      type: t,
      day: Number(state.day) || 1,
      short_month_policy: state.short_month_policy || 'clamp_last',
    };
  }
  if (t === 'monthly_weekday') {
    return {
      type: t,
      weekday: Number(state.weekday),
      ordinal: state.ordinal === 'last' ? 'last' : Number(state.ordinal) || 1,
    };
  }
  if (t === 'weekly') {
    return {
      type: t,
      weekday: Number(state.weekday),
      interval_weeks: Number(state.interval_weeks) || 1,
      anchor_date: state.anchor_date,
    };
  }
  return { type: 'every_n_days', interval_days: 30, anchor_date: state.anchor_date };
}

export default function ScheduleForm({ value, onChange }) {
  const set = (patch) => onChange({ ...value, ...patch });

  return (
    <div className="Finance-scheduleForm">
      <label className="Finance-field">
        <span className="Finance-label">Тип расписания</span>
        <select
          value={value.type}
          onChange={(e) => set({ type: e.target.value })}
        >
          {SCHEDULE_TYPES.map((t) => (
            <option key={t.id} value={t.id}>{t.label}</option>
          ))}
        </select>
      </label>

      {value.type === 'yearly_date' && (
        <>
          <label className="Finance-field">
            <span className="Finance-label">Месяц (1–12)</span>
            <input type="number" min={1} max={12} value={value.month}
              onChange={(e) => set({ month: e.target.value })} />
          </label>
          <label className="Finance-field">
            <span className="Finance-label">Число месяца</span>
            <input type="number" min={1} max={31} value={value.day}
              onChange={(e) => set({ day: e.target.value })} />
          </label>
          <small>Для 29 февраля в невисокосный год — 28 февраля.</small>
        </>
      )}

      {value.type === 'daily_from_monthly' && (
        <>
          <label className="Finance-field">
            <span className="Finance-label">Первый день списаний</span>
            <input type="date" value={value.anchor_date}
              onChange={(e) => set({ anchor_date: e.target.value })} />
          </label>
          <small>Месячная сумма распределяется по всем дням месяца без потери копеек.</small>
        </>
      )}

      {value.type === 'every_n_days' && (
        <>
          <label className="Finance-field">
            <span className="Finance-label">Интервал (дней)</span>
            <input
              type="number"
              min={1}
              value={value.interval_days}
              onChange={(e) => set({ interval_days: e.target.value })}
            />
          </label>
          <label className="Finance-field">
            <span className="Finance-label">Дата отсчёта</span>
            <input
              type="date"
              value={value.anchor_date}
              onChange={(e) => set({ anchor_date: e.target.value })}
            />
          </label>
        </>
      )}

      {value.type === 'monthly_day' && (
        <>
          <label className="Finance-field">
            <span className="Finance-label">Число месяца</span>
            <input
              type="number"
              min={1}
              max={31}
              value={value.day}
              onChange={(e) => set({ day: e.target.value })}
            />
          </label>
          <label className="Finance-field">
            <span className="Finance-label">Короткий месяц</span>
            <select
              value={value.short_month_policy}
              onChange={(e) => set({ short_month_policy: e.target.value })}
            >
              <option value="clamp_last">Последний день месяца</option>
              <option value="skip">Пропустить</option>
            </select>
          </label>
        </>
      )}

      {value.type === 'monthly_weekday' && (
        <>
          <label className="Finance-field">
            <span className="Finance-label">День недели</span>
            <select value={value.weekday} onChange={(e) => set({ weekday: e.target.value })}>
              {WEEKDAYS.map((w) => (
                <option key={w.v} value={w.v}>{w.label}</option>
              ))}
            </select>
          </label>
          <label className="Finance-field">
            <span className="Finance-label">Какой в месяце</span>
            <select value={value.ordinal} onChange={(e) => set({ ordinal: e.target.value })}>
              <option value={1}>1-й</option>
              <option value={2}>2-й</option>
              <option value={3}>3-й</option>
              <option value={4}>4-й</option>
              <option value="last">Последний</option>
            </select>
          </label>
        </>
      )}

      {value.type === 'weekly' && (
        <>
          <label className="Finance-field">
            <span className="Finance-label">День недели</span>
            <select value={value.weekday} onChange={(e) => set({ weekday: e.target.value })}>
              {WEEKDAYS.map((w) => (
                <option key={w.v} value={w.v}>{w.label}</option>
              ))}
            </select>
          </label>
          <label className="Finance-field">
            <span className="Finance-label">Каждые N недель</span>
            <input
              type="number"
              min={1}
              value={value.interval_weeks}
              onChange={(e) => set({ interval_weeks: e.target.value })}
            />
          </label>
          <label className="Finance-field">
            <span className="Finance-label">Дата отсчёта</span>
            <input
              type="date"
              value={value.anchor_date}
              onChange={(e) => set({ anchor_date: e.target.value })}
            />
          </label>
        </>
      )}
    </div>
  );
}
